import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BottomFooter from "../../components/BottomFooter";
import { getStoredConsent, normalizeConsent, saveConsent } from "../../util/tracking";
import backIcon from "../../public/icons/ZurückIcon.svg";
import classes from "./CookieSettingsPage.module.css";

const defaultSelection = {
  analytics: false,
  marketing: false,
};

export default function CookieSettingsPage() {
  const [selection, setSelection] = useState(defaultSelection);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const consent = getStoredConsent();
    if (!consent) return;

    setSelection({
      analytics: consent.analytics,
      marketing: consent.marketing,
    });
  }, []);

  const handleChange = (event) => {
    const { name, checked } = event.target;
    setSaved(false);
    setSelection((currentSelection) => ({
      ...currentSelection,
      [name]: checked,
    }));
  };

  const handleSave = () => {
    saveConsent(normalizeConsent(selection));
    setSaved(true);
  };

  return (
    <div className={classes.page}>
      <main className={classes.container}>
        <Link to="/" className={classes.backLink}>
          <span className={classes.backIcon} aria-hidden="true">
            <img src={backIcon} alt="" />
          </span>
          <span>Zurück zur Startseite</span>
        </Link>
        <p className={classes.eyebrow}>Privatsphäre</p>
        <h1>Cookie Einstellungen</h1>
        <p className={classes.intro}>
          Hier kannst du festlegen, welche optionalen Dienste auf Stu geladen werden.
          Notwendige Cookies bleiben aktiv, damit die Website funktioniert. Die
          konkreten Anbieter findest du in der Datenschutzerklärung.
        </p>

        <section className={classes.settings} aria-label="Cookie Kategorien">
          <div className={classes.setting}>
            <div>
              <h2>Notwendig</h2>
              <p>Erforderlich für Login, Sicherheit und Grundfunktionen.</p>
            </div>
            <span className={classes.alwaysActive}>Immer aktiv</span>
          </div>

          <label className={classes.setting}>
            <div>
              <h2>Statistik</h2>
              <p>Hilft uns zu verstehen, wie Stu genutzt wird und wo wir die Website verbessern können.</p>
            </div>
            <input
              type="checkbox"
              name="analytics"
              checked={selection.analytics}
              onChange={handleChange}
            />
          </label>

          <label className={classes.setting}>
            <div>
              <h2>Marketing</h2>
              <p>Hilft uns, Kampagnen und Anzeigen zu messen und relevanter auszuspielen.</p>
            </div>
            <input
              type="checkbox"
              name="marketing"
              checked={selection.marketing}
              onChange={handleChange}
            />
          </label>
        </section>

        <div className={classes.actions}>
          <button className={classes.saveButton} type="button" onClick={handleSave}>
            Einstellungen speichern
          </button>
          {saved && <p className={classes.saved}>Gespeichert.</p>}
        </div>
      </main>
      <BottomFooter fromKontakt={true} />
    </div>
  );
}
